var map = {
	"./alf.scss": [
		52620,
		2620
	],
	"./main.scss": [
		79160,
		9160
	],
	"./oh-poppy.scss": [
		27465,
		7465
	],
	"./vincent.scss": [
		4040,
		4040
	],
	"./wtg.scss": [
		93875,
		3875
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 84894;
module.exports = webpackAsyncContext;